/* @ngInject */
function CostFolderFactory($http, Cost, $rootScope) {
  class CostFolder {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/cost-folders`;
    }

    isNew() {
      return !this._id;
    }

    isSubfolderOf(costFolder) {
      if (!this.ancestors || this.ancestors.length === 0) return false;

      this.ancestors.some((ancestor) => ancestor._id === costFolder._id);
    }

    canMove(destinationCostFolder) {
      // Si la carpeta de destino es la raiz y ya esta en la carpeta raiz
      if (!destinationCostFolder._id && this.parent === null) return false;

      // Si la carpeta de destino no es la carpeta raiz
      if (destinationCostFolder._id) {
        const parentId = this.parent && this.parent._id ? this.parent._id : null;

        // If it's the same folder (cost and folders)
        if (parentId === destinationCostFolder._id) return false;

        // If folder to move it's the same folder that destination folder
        if (this._id === destinationCostFolder._id) return false;

        // If destination folder is a sub folder of folder to move
        if (destinationCostFolder.isSubfolderOf(this)) return false;
      }

      return true;
    }

    static query(params) {
      return $http
        .get(CostFolder.getResourceUrl(), { params })
        .then((response) => response.data.map((costFolderData) => new CostFolder(costFolderData)));
    }

    static queryByParent(parentId) {
      return $http
        .get(CostFolder.getResourceUrl(), {
          params: { parent: parentId || "null" },
        })
        .then((response) => response.data.map((costFolderData) => new CostFolder(costFolderData)));
    }

    static get(id) {
      return $http.get(`${CostFolder.getResourceUrl()}/${id}`).then((response) => new CostFolder(response.data));
    }

    static getChildren(id) {
      return $http
        .get(`${CostFolder.getResourceUrl()}/${id}/children`)
        .then((response) =>
          response.data.map((data) => (data.price && data.unit ? new Cost(data) : new CostFolder(data))),
        );
    }

    save() {
      return this.isNew() ? this.create() : this.update();
    }

    create() {
      if (!this.isNew()) throw new Error("The cost folder is already created");

      return $http.post(CostFolder.getResourceUrl(), this).then((response) => angular.extend(this, response.data));
    }

    update() {
      if (this.isNew()) throw new Error("Can not update a cost folder that has not been created");

      return $http
        .put(`${CostFolder.getResourceUrl()}/${this._id}`, this)
        .then((response) => angular.extend(this, response.data));
    }

    move(parent) {
      if (this.isNew()) throw new Error("Can not move a cost folder that has not been created");

      return $http
        .put(`${CostFolder.getResourceUrl()}/${this._id}/move`, { parent })
        .then((response) => angular.extend(this, response.data));
    }

    delete() {
      if (this.isNew()) throw new Error("Can not delete a cost folder that has not been created");

      return $http.delete(`${CostFolder.getResourceUrl()}/${this._id}`).then(() => true);
    }
  }

  return CostFolder;
}

export default CostFolderFactory;
